import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService, SelectItem} from 'primeng/api';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth.service';
import {interval, Subscription} from 'rxjs';


@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css', '../../assets/layout/style/layout.css'],
  providers: [MessageService]
})
export class OtpComponent implements OnInit {
  n1 = '-';
  n2 = '-';
  n3 = '-';
  n4 = '-';
  n5 = '-';
  n6 = '-';
  numbersInput: any = [];
  userform: FormGroup;
  submitted: boolean;
  sendedToken: boolean;
  items: any[];
  typeValidate = '1';
  typeRequest = '1';
  timer = 0;
  countryTitle: string;
  selectedCity: string;
  phoneTitle: string;
  emailTitle: string;
  dpiTitle: string;
  private subscription: Subscription;
  loginBtnTitle: string;
  fcmToken: string;
  masks = 'dd/MM/yyyy';
  env = environment;
  constructor(private realm: RealmService, private api: ApiService, private st: SessionService,
              private Rc: FirebaseService, private fb: FormBuilder, private auth: AuthService,
              private router: Router, private messageService: MessageService) {
    this.getFcm();
  }

  ngOnInit() {
    /* this.realm.loginAsync().then(data=>{
      console.log(data);
    }); */
    this.getFcm();
    
    /*
    if (this.env.sendOtpNewDevice) {
      this.sendedToken = true;
      this.resendSms('1','2'); //reenviar token 
    }*/
    
    this.api.responseApiOtp$
      .subscribe((data:any) => {
        console.log('data ws: ', data);
        const dat = JSON.parse(JSON.stringify(data));
        this.env.isContentLoading = false;
        // @ts-ignore
        if (data.code === 701 ) {
          console.log("typerequest ",this.typeRequest);
          if (this.typeRequest == '1') {
            // @ts-ignore
            const s: object = dat.result;
            //const a = s.success;
            if ( this.sendedToken ) {
              this.messageService.add({severity: 'info', summary: 'info', detail: 'Token Enviado..', sticky: false});
            } else {
              this.st.saveParam('register', 'true');
              this.auth.setOtpIn(true);
              this.router.navigate(['/home']);
            }
          } else {
            this.messageService.add({severity: 'info', summary: 'info', detail: 'Token Enviado..', sticky: false});
          }
        } else if (data.code === 622 ) {
          this.messageService.add({severity: 'error', summary: 'error', detail: 'No se encontró OTP', sticky: false});
          //SOLUCION ALTERNA 
          //this.st.saveParam('register', 'true');
          //this.auth.setOtpIn(true);
          //this.router.navigate(['/home']);
        } else if (data.code === 200 ) {
          this.messageService.add({severity: 'success', summary: 'Exito', detail: 'No se encontró OTP', sticky: false});
        } else {
          console.log(this.Rc.getStringRC('global_message_' + data.code));
          // tslint:disable-next-line:max-line-length
          this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + data.code), sticky: false});
        }
      });
      /*
    this.realm.countriesArea$.subscribe(data => {
      // @ts-ignore
      this.items = data.data.countryCodeAppSettingsOrms;
    });*/
    this.Rc.fetchActivate().then(() => {
      console.log('pais:::::: ', this.Rc.getStringRC('global_select_country_title'));
    });
    this.realm.getCountriesArea().then((data:any) => {
      this.items = data.data.countryCodeAppSettingsOrms;
    })
    this.userform = this.fb.group({
      n1: new FormControl('', [Validators.required, Validators.minLength(1)]),
      n2: new FormControl('', [Validators.required, Validators.minLength(1)]),
      n3: new FormControl('', [Validators.required, Validators.minLength(1)]),
      n4: new FormControl('', [Validators.required, Validators.minLength(1)]),
      n5: new FormControl('', [Validators.required, Validators.minLength(1)]),
      n6: new FormControl('', [Validators.required, Validators.minLength(1)]),
    });
    //this.selectedCity = this.userform.get('country').value;
  }

  ngAfterViewInit() {
    console.log("------ngAfterViewInit OTP--------")
    if (this.env.sendOtpNewDevice) {
      console.log("entra a enviar token desde afterviewinit");
      this.sendedToken = true;
      this.resendSms('1','2'); //reenviar token 
    }
    this.messageService.add({severity: 'info', summary: 'info', detail: 'Token Enviado..', sticky: false});
  }
  setvalues() {
    const t =  this.items[1];
  }
  onSubmit() {
    this.env.isContentLoading = true;
    this.submitted = true;
    //this.messageService.add({severity: 'info', summary: 'Success', detail: 'Form Submitted', sticky: false});
    let codeVerification = this.n1 + "" + this.n2 + "" + this.n3 + "" + this.n4 + "" + this.n5 + "" + this.n6;
    /*console.log("submit value otp "+value);
    const q = JSON.parse(JSON.stringify(value));
    const code = ""+q.n1 +""+ q.n2 +""+ q.n3  +""+ q.n4 +""+ q.n5 +""+ q.n6;*/
    console.log("codigo armado "+codeVerification);
    this.typeRequest = '1';
    this.sendedToken = false;
    this.realm.getOtpSettings(codeVerification, this.typeValidate, this.typeRequest);
  }
  resendSms(validate: string, request: string) {
    this.typeRequest = request;
    this.typeValidate = validate;
    if (this.timer === 0) {
      //this.sendedToken = false;
      this.realm.getOtpSettings('', validate, request);
    }
    this.startTimer();
  }
  getFcm() {
    this.st.getvvalueSession('data', 'fcmToken').then( r => {
      this.fcmToken = r;
    });
  }
  numberclicked(n: number) {
      if (n >= 0) {
        if (this.numbersInput.length >= 0 && this.numbersInput.length < 6) {
          this.numbersInput.push({n});
          if (this.numbersInput.length > 0) {
            // tslint:disable-next-line:forin
          this.updateNumbers();
          }
        }
      } else {
        if (this.numbersInput.length > 0 ) {
          this.numbersInput[this.numbersInput.length - 1].n = '-';
          this.updateNumbers();
          this.numbersInput.splice(this.numbersInput.length - 1, 1);
        }
      }
  }
  updateNumbers() {
    // tslint:disable-next-line:forin
    for (const numbersInputKey in this.numbersInput) {
      switch (numbersInputKey) {
        case '0': {this.n1 = this.numbersInput[numbersInputKey].n;  break; }
        case '1': {this.n2 = this.numbersInput[numbersInputKey].n;  break; }
        case '2': {this.n3 = this.numbersInput[numbersInputKey].n;  break; }
        case '3': {this.n4 = this.numbersInput[numbersInputKey].n;  break; }
        case '4': {this.n5 = this.numbersInput[numbersInputKey].n;  break; }
        case '5': {this.n6 = this.numbersInput[numbersInputKey].n;  break; }
      }
    }
  }
  onDigitInput(event) {

    let element;
    if (event.code !== 'Backspace') {
      element = event.srcElement.nextElementSibling;
    }

    if (event.code === 'Backspace') {
      element = event.srcElement.previousElementSibling;
    }

    if (element == null) {
      return;
    } else {
      element.focus();
    }
  }
  startTimer() {
    let timer = 30;
    let seconds;
    this.subscription = interval(1000).subscribe( x => {
      seconds = Math.floor(timer % 60);
      // seconds = seconds < 10 ? '0' + seconds : seconds;
      this.timer = seconds;
      if (--timer < 0) {
        this.subscription.unsubscribe();
      } else {
        //--timer;
      }
    });
  }

  cancel() {
    this.router.navigate(['/login']);
  }
}
